import React from 'react';
import HasFeature from '../HasFeature';
import { FeatureFlagName } from 'shared/enums/FeatureFlagName';
import { Flex } from '@televet/kibble-ui/build/chakra';
import { Icon } from '@televet/kibble-ui/build/components/Icon';
import {
  CareSubscriptionStatus,
  getCareBadgeBackgroundColor,
  getCareBadgeIconVariantColor,
} from '../SidePanel/components/SearchPanel/components/Benefits/utils/careEnrollments';

interface ICareBadgeProps {
  isCareMember: boolean;
  paymentStatus?: CareSubscriptionStatus | null;
  marginleft?: string;
  margintop?: string;
  position?: string;
  fill?: string | null | undefined;
}

const CareBadge = ({ isCareMember, marginleft, margintop, position, paymentStatus }: ICareBadgeProps): JSX.Element => {
  return (
    <HasFeature name={FeatureFlagName.CarePlans}>
      {isCareMember && (
        <Flex
          // eslint-disable-next-line
          // @ts-ignore
          position={position || 'relative'}
          top={margintop}
          right={marginleft}
          background={getCareBadgeBackgroundColor(paymentStatus)}
          border="1px"
          borderColor="border.strongContrast"
          borderRadius="full"
          w="18px"
          h="18px"
          alignItems="center"
          justifyContent="center"
        >
          <Icon name="starSolid" variant={getCareBadgeIconVariantColor(paymentStatus)} size="xs" />
        </Flex>
      )}
    </HasFeature>
  );
};

export default CareBadge;
